import _ from 'lodash';
import React from 'react';
import Reflux from 'reflux';
import cx from 'classnames';
import { Link } from 'react-router';
import { fromJS } from 'immutable';
import { Nav } from 'react-bootstrap';
import Store from './store';
import Actions from './actions';

const BASE_URL = "/infographics/elections";

const DateSelector = React.createClass({

  mixins: [ Reflux.listenTo(Store, 'onDataChange')],

  getInitialState() {
    return {
      months: fromJS({})
    };
  },

  getClassName(month) {
    return cx({
      active: (this.props.params.month === month),
      open: (this.props.params.month === month)
    });
  },

  componentWillMount() {
    Actions.getMonths();
  },

  onDataChange(data) {
    this.setState(data);
  },

  _renderMonths() {
    const dataset = this.props.location.pathname.split('/')[3];
    return _.map(this.state.months.toJS(), (array) => {
      const month = array[0];
      const waves = array[1];
      const lastWave = _.last(waves) || {};
      return (
        <li key={month} className={this.getClassName(month)}>
          <Link
            to={{ pathname: `${BASE_URL}/${dataset}/${month}/${lastWave.wave}` }}
            activeClassName="active"
          >{month.replace('-', ' ').split(' ')[0]}
          </Link>
        </li>
      );
    });
  },

  _renderAllLink(dataset, waves, month) {
    if (waves.length > 1){
      return (
        <li>
          <Link to={{ pathname: `${BASE_URL}/${dataset}/${month}` }} activeClassName="active">
            All
          </Link>
        </li>
      )
    }
  },

  _renderWaves(dataset, waves, month) {

    return _.map(waves, (wave, key) => {
      return (
        <li key={key}>
          <Link to={{ pathname: `${BASE_URL}/${dataset}/${month}/${wave.wave}` }} activeClassName="active">
            {wave.date}
          </Link>
        </li>
      );
    })
  },

  render() {
    return (
      <Nav>{ this._renderMonths() }</Nav>
    );
  }

});

export default DateSelector;




/** WEBPACK FOOTER **
 ** ./src/components/data_visualisation/date_selector.js
 **/